<template>
    <div class="list" :style="{top:`${top}px`}">
        <PullRefresh :value="isRefresh" @refresh="handleRefresh" ref="pullRefresh" >
            <div class="list-container" ref="listContainer">
               <slot></slot>
            </div>
            <Empty v-show="!length" :style="{height:`calc(100vh - ${top}px)`}" class="empty"/>
            <!-- <div class="footer" v-show="isScroll">已经到底啦</div> -->
        </PullRefresh>
    </div>
</template>
<script>
import { debounce } from "utils/baseMethods.js";
export default {
  props: {
    /**
     * @description 一共有多少条数据
     */
    total: {
      type: Number,
      default: 0
    },
    /**
     * @description 当前有多少条数据
     */
    length: {
      type: Number,
      default: 0
    },
    /**
     * @description 由于滚动必须要去元素本身有高度 暂时由外部传入 TODO 更改为自身获取
     */
    top: {
      type: Number,
      default: 0
    },
    /**
     * @description 是否要下拉刷新
     */
    isPullRefresh: {
      type: Boolean,
      default: true
    },
    /**
     * @description 控制下拉刷新状态
     */
    isRefresh: {
      type: Boolean,
      default: false
    },
    isScroll:{
      type: Boolean,
      default: false
    }
  },
  watch:{
  
  },
  data() {
    return {
      positionTop: 0
    };
  },
  created() {
    this.$nextTick(() => {
      this.$el.onscroll = debounce(() => {
        const scrollHeight = this.$el.scrollHeight;
        const scrollTop = this.$el.scrollTop;
        const clientHeight = this.$el.clientHeight;
        if (scrollHeight - (clientHeight + scrollTop) <= 50) {
          if (this.total !== this.length) {
            this.$emit("scroll");
          }
        }
      }, 100);
    });
  },
  methods: {
      handleRefresh(){
          this.$emit('refresh',this);
      },
      /**
       * @description 设置list滚动到哪个地方
       */
      setScrollTop(scrollTop){
        scrollTop += ''
        if (scrollTop) {
          this.$el.scrollTop = Number(scrollTop)
        }else{
          console.log(scrollTop,'滚动高度为空')
        }
      }
  }
};
</script>
<style lang="less" scoped>
.list {
  width: 100%;
  height: auto;
  overflow: auto;
  position: absolute;
  bottom: 0;
  .footer {
    background: #f0f0f0;
    text-align: center;
    font-size: 12px;
    color: #969799;
    font-size: 14px;
    text-align: center;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    // position: fixed;
    // width: 100%;
    // bottom:0;
  }

}

</style>
<style lang="less">
.list{
    .van-pull-refresh__track{
        height: 100%;
    }
}
</style>